import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.index-of";
import $ from 'jquery';
import { XMLStr2XMLDoc } from '@/components/TwVideo/CommonFunctions';
import { OCX_XML_Initial, OCX_XML_SetLoginInfo, OCX_XML_SetRecLocation, OCX_XML_SetScreenMode, OCX_XML_SetProperty, OCX_XML_SetRecPlayMode, OCX_XML_SearchRec, OCX_XML_SetPlayStatus } from '@/components/TwVideo/OCXCommon';
var promiseContext = null;
var timePromiseContext = null;
var twbBackHandle = {
  InitialComplete: function InitialComplete(state, $xmlDoc) {
    if ($xmlDoc.text().indexOf('Login') !== -1) {
      if (promiseContext) {
        promiseContext.resolve();
        state.statenotifyType = '';
        promiseContext = null;
      }
    }
  },
  connectstate: function connectstate(state, $xmlDoc) {
    if ($xmlDoc.text().indexOf('success') !== -1) {
      if (promiseContext) {
        promiseContext.resolve();
        state.statenotifyType = '';
        state.isLogin = true;
        promiseContext = null;
      }
    }
  },
  RecSearch: function RecSearch(state, $xmlDoc) {
    if ($xmlDoc.text().indexOf('success') !== -1) {
      if ($xmlDoc.find('recList').children().length) {
        if (promiseContext) {
          promiseContext.resolve();
          state.statenotifyType = '';
          promiseContext = null;
        }
      } else {
        promiseContext.reject(1);
      }
    } else {
      promiseContext.reject(0);
    }
  },
  CurrentSelectedWindow: function CurrentSelectedWindow(state, $xmlDoc) {
    if (promiseContext) {
      promiseContext.resolve();
      state.statenotifyType = '';
      promiseContext = null;
    }
  }
};
var timeTwbBackHandle = {
  InitialComplete: function InitialComplete(state, $xmlDoc) {
    if (timePromiseContext) {
      timePromiseContext.resolve();
      state.statenotifyType = '';
      timePromiseContext = null;
    }
  }
};
var state = {
  isLogin: false,
  // 是否初始化并登陆成功
  OCXPlugin: null,
  // 插件实例
  TimeBarOCX: null,
  // 视屏回放时候的时间条插件
  isAction: false,
  // 是否有正在执行的操作
  statenotifyType: '',
  // 信息类型
  timeStatenotifyType: '' // 时间控件信息类型
};
var mutations = {
  logout: function logout(state) {
    state.isLogin = false;
    state.OCXPlugin = null;
    state.TimeBarOCX = null;
    state.isAction = false;
    state.statenotifyType = '';
    state.timeStatenotifyType = '';
  },
  setOCXPlugin: function setOCXPlugin(state, OCXPlugin) {
    state.OCXPlugin = OCXPlugin;
  },
  setTimeBarOCX: function setTimeBarOCX(state, TimeBarOCX) {
    state.TimeBarOCX = TimeBarOCX;
  },
  setStatenotifyType: function setStatenotifyType(state, statenotifyType) {
    state.statenotifyType = statenotifyType;
  },
  setTimeStatenotifyType: function setTimeStatenotifyType(state, timeStatenotifyType) {
    state.timeStatenotifyType = timeStatenotifyType;
  },
  setActionStatus: function setActionStatus(state, isAction) {
    state.isAction = isAction;
  },
  twbBack: function twbBack(state, strXMLFormat) {
    var $xmlDoc = $(XMLStr2XMLDoc(strXMLFormat));
    if ($xmlDoc.find('statenotify')) {
      var statenotifyType = $xmlDoc.find('statenotify').attr('type');
      if (state.statenotifyType === statenotifyType && twbBackHandle[statenotifyType]) {
        twbBackHandle[statenotifyType](state, $xmlDoc);
      }
    }
    if ($("statenotify[type='RecCurPlayTime']", $xmlDoc).length > 0) {
      var sendXML1 = strXMLFormat.replace('<statenotify type="RecCurPlayTime">', '<cmd type="RecCurPlayTime">').replace('</statenotify>', '</cmd>');
      state.TimeBarOCX.ExecuteCmd(sendXML1, sendXML1.length);
    }
    if ($("statenotify[type='RecPlay']", $xmlDoc).length > 0) {
      var sendXML2 = strXMLFormat.replace('<statenotify type="RecPlay">', '<cmd type="SetRecList">').replace('</statenotify>', '</cmd>');
      state.TimeBarOCX.ExecuteCmd(sendXML2, sendXML2.length);
    }
    if ($("statenotify[type='RecSearch']", $xmlDoc).length > 0) {
      var sendXML3 = strXMLFormat.replace('<statenotify type="RecSearch">', '<cmd type="SetRecList">').replace('</statenotify>', '</cmd>');
      state.TimeBarOCX.ExecuteCmd(sendXML3, sendXML3.length);
    }
    if ($("statenotify[type='CurrentSelectedWindow']", $xmlDoc).length > 0) {
      // 将窗口信息通知给另一个OCX
      var sendXML4 = strXMLFormat.replace('<statenotify type="CurrentSelectedWindow">', '<cmd type="CurrentSelectedWindow">').replace('</statenotify>', '</cmd>');
      state.TimeBarOCX.ExecuteCmd(sendXML4, sendXML4.length);
    }
    if ($("statenotify[type='CurrentFrameNum']", $xmlDoc).length > 0 || $("statenotify[type='CurrentScreenMode']", $xmlDoc).length > 0) {
      var segNum = $.trim($('statenotify', $xmlDoc).text());
      var sendXML5 = OCX_XML_SetScreenMode(segNum);
      state.TimeBarOCX.ExecuteCmd(sendXML5, sendXML5.length);
    }
  },
  timeTwbBack: function timeTwbBack(state, strXMLFormat) {
    var $xmlDoc = $(XMLStr2XMLDoc(strXMLFormat));
    if ($xmlDoc.find('statenotify')) {
      var statenotifyType = $xmlDoc.find('statenotify').attr('type');
      if (state.timeStatenotifyType === statenotifyType && timeTwbBackHandle[statenotifyType]) {
        timeTwbBackHandle[statenotifyType](state, $xmlDoc);
      }
    }

    // 播放进度
    if ($("statenotify[type='RecCurPlayTime']", $xmlDoc).length > 0) {
      var sendXML1 = strXMLFormat.replace('<statenotify type="RecCurPlayTime">', '<cmd type="RecCurPlayTime">').replace('</statenotify>', '</cmd>');
      state.OCXPlugin.ExecuteCmd(sendXML1, sendXML1.length);
    } else if ($("statenotify[type='InitialComplete']", $xmlDoc).length > 0) {
      // OCX已创建好窗口，通知可以登录了
      var sendXML2 = OCX_XML_SetProperty({
        calendarType: 'Gregorian'
      });
      var sendXML3 = OCX_XML_SetRecPlayMode('uSYNC"');
      state.TimeBarOCX.ExecuteCmd(sendXML2, sendXML2.length);
      state.OCXPlugin.ExecuteCmd(sendXML3, sendXML3.length);
      state.TimeBarOCX.ExecuteCmd(sendXML3, sendXML3.length);
    }
  }
};
var actions = {
  InitialComplete: function InitialComplete(_ref) {
    var commit = _ref.commit,
      state = _ref.state;
    commit('setStatenotifyType', 'InitialComplete');
    commit('setActionStatus', true);
    return new Promise(function (resolve, reject) {
      promiseContext = {
        resolve: resolve,
        reject: reject
      };
      var sendXML = '';
      sendXML = OCX_XML_Initial('Interactive', 'zh-cn', 'RecNotify2Js', 'Playback');
      state.OCXPlugin.ExecuteCmd(sendXML, sendXML.length);
    });
  },
  TimeInitialComplete: function TimeInitialComplete(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    commit('setTimeStatenotifyType', 'InitialComplete');
    commit('setActionStatus', true);
    return new Promise(function (resolve, reject) {
      timePromiseContext = {
        resolve: resolve,
        reject: reject
      };
      var sendXML = '';
      sendXML = OCX_XML_Initial(null, 'zh-cn', 'TimeSliderNotify2Js', 'TimeSlider');
      state.TimeBarOCX.ExecuteCmd(sendXML, sendXML.length);
    });
  },
  connectstate: function connectstate(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    commit('setStatenotifyType', 'connectstate');
    commit('setActionStatus', true);
    return new Promise(function (resolve, reject) {
      promiseContext = {
        resolve: resolve,
        reject: reject
      };
      var sendXML1 = OCX_XML_SetLoginInfo('admin', '123456', '192.168.4.206', '6003', '');
      state.OCXPlugin.ExecuteCmd(sendXML1, sendXML1.length);
      var sendXML2 = OCX_XML_SetRecLocation('NET_DEVBIND');
      state.OCXPlugin.ExecuteCmd(sendXML2, sendXML2.length);
    });
  },
  RecPlay: function RecPlay(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    var par = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    commit('setStatenotifyType', 'RecSearch');
    commit('setActionStatus', true);
    return new Promise(function (resolve, reject) {
      promiseContext = {
        resolve: resolve,
        reject: reject
      };
      var sendXML = OCX_XML_SearchRec('RecSearch', par.startTime, par.endTime, par.winIndexList, par.chlIdList, [], ['MANUAL', 'MOTION', 'SENSOR', 'SCHEDULE', 'OSC', 'AVD', 'TRIPWIRE', 'PERIMETER', 'INTELLIGENT', 'POS']);
      state.OCXPlugin.ExecuteCmd(sendXML, sendXML.length);
    });
  },
  Leave: function Leave(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    var sendXML = OCX_XML_SetPlayStatus('STOP', 0);
    state.OCXPlugin.ExecuteCmd(sendXML, sendXML.length);
    commit('logout');
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};